import { Select } from 'antd'
import { t } from 'i18next'
import { useCallback, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { SelectOption } from '../../../../types/generalTypes'
import { routePaths } from '../../../RootPage'

export type CompensationMatrixAnalysisPanel = 'MATCHING' | 'FILTERING'
export interface CompensationMatrixAnalysisPanels {
  FILTERING: CompensationMatrixAnalysisPanel
  MATCHING: CompensationMatrixAnalysisPanel
}
export const compensationMatrixAnalysisPanels: CompensationMatrixAnalysisPanels =
  {
    FILTERING: 'FILTERING',
    MATCHING: 'MATCHING',
  }

const CompensationMatrixAnalysisSelectPanel = () => {
  const { workspaceId, algorithmRunId, panel } = useParams()
  const navigate = useNavigate()

  const [selectedValue, setSelectedValue] = useState<string | undefined>(panel)

  const handleChange = useCallback(
    (value?: string) => {
      setSelectedValue(value)
      const url = `${routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_CC_FC_COMPENSATION_MATRIX_ANALYSIS}/${workspaceId}/${algorithmRunId}/${value}`
      navigate(url)
    },
    [workspaceId, algorithmRunId, navigate]
  )

  const options: SelectOption[] = useMemo(
    () => [
      {
        label: t(
          'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.panels.matching'
        ),
        value: compensationMatrixAnalysisPanels.MATCHING,
      },
      {
        label: t(
          'smartFunctionDetailsPage.cellCartaCompensationMatrixAnalysis.panels.filtering'
        ),
        value: compensationMatrixAnalysisPanels.FILTERING,
      },
    ],
    []
  )

  return (
    <Select
      onChange={handleChange}
      defaultValue={panel}
      value={selectedValue}
      options={options}
    />
  )
}

export default CompensationMatrixAnalysisSelectPanel
